import { FamilyRegistrationYear } from './../family-registration-year.model';
import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { FamilyRegistrationService } from '../family-registration.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { LoginSettings } from '../../../shared-modules/login/LoginSetting.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { ReEnrollStudentsComponent } from '../../../shared-components/student-header/re-enroll-students/re-enroll-students.component';

@Component({
	selector: 'app-new-family-registration-year-selection',
	templateUrl: './new-family-registration-year-selection.component.html',
	styleUrls: [
		'./new-family-registration-year-selection.component.css',
		'../familiy-registration-shared-style.css'
	]
})
export class NewFamilyRegistrationYearSelectionComponent implements OnInit {
	years: FamilyRegistrationYear[];
	ids: string[] = [];
	labels: string[] = [];
	public errorList: ErrorList[] = [];
	LoginSettings: LoginSettings;
	defaultYear: FamilyRegistrationYear;
	V10: boolean;
	reEnrollStudent = false;

	constructor(
	    @Inject(MAT_DIALOG_DATA) private data: any,
		private familyRegistrationService: FamilyRegistrationService,
		private loginService: LoginService,
		private dialogRef: MatDialogRef<NewFamilyRegistrationYearSelectionComponent>,
		private router: Router,
        private dialog: MatDialog,
	) { }

	ngOnInit() {
		if (this.data != undefined) {
			this.reEnrollStudent = this.data.reEnrollStudent;
		}
		this.V10 = this.loginService.LoginSettings.V10;
		this.LoginSettings = this.loginService.LoginSettings;
		this.defaultYear = this.familyRegistrationService.defaultYear;
		if (this.reEnrollStudent) {
			this.years = this.data.years;
		}
		else {
			this.years = this.familyRegistrationService.years;
		}
		for (let i = 0; i < this.years.length; i++) {
			this.ids.push('yearRadio' + i);
			let yearLabel = '';
			if (this.V10) {
				if (this.years[i].Status == 1) {
					yearLabel += 'The current school year ';
				}
				if (this.years[i].Status == 2) {
					yearLabel += 'The upcoming school year ';
				}
			}
			yearLabel += this.years[i].Description;
			this.labels.push(yearLabel);
		}
	}

	modalInstanceOKClick() {
		this.dialogRef.close('OK was clicked.');
		this.familyRegistrationService.saveRegisterParent(this.familyRegistrationService.householdParent).subscribe(
			() => {
				this.router.navigateByUrl('/familyregistration/householdparent');
			});
	}

	modalInstanceNextClick() {
		if (this.validate() && this.reEnrollStudent) {
			const dialogBox = this.dialog.open(ReEnrollStudentsComponent,
                {
                    disableClose: true,
                    width: '65vw',
                    height: '58vh',
                    data: {
                        yearId: this.defaultYear.Id,
						familyId: this.data.familyId,
						selectedYear: this.defaultYear
                    }
                });
    
            const subscription = dialogBox.afterClosed().subscribe(result => {
                if (result == 'Close') {
					this.router.navigateByUrl('/student360/onlineRegistration');
					this.dialogRef.close('OK was clicked.');
				}
				else if (result == 'Cancel') {
					this.dialogRef.close('OK was clicked.');
				}
            });
		}
		else {
			if (this.validate()) {
				this.dialogRef.close('Next was clicked.');
				this.familyRegistrationService.defaultYear = this.defaultYear;
				this.familyRegistrationService.householdParent.YearId = this.familyRegistrationService.defaultYear.Id;
				this.familyRegistrationService.householdParent.AyIdentifier = this.loginService.LoginSettings.V10 ? this.familyRegistrationService.defaultYear.AYIdentifier : this.familyRegistrationService.defaultYear.Description;
				this.familyRegistrationService.saveRegisterParent(this.familyRegistrationService.householdParent).subscribe(
					() => {
						this.router.navigateByUrl('/familyregistration/householdparent');
					});
			}
		}
	}

	validate(): boolean {
		this.errorList = [];
		if (!this.defaultYear || this.defaultYear.Id == undefined) {
			let htmlElement: Element = document.getElementById(this.ids[0]);
			htmlElement = htmlElement.getElementsByClassName('mat-radio-input')[0];
			const element = new ElementRef(htmlElement);
			this.errorList.push({
				fieldName: 'Year',
				fieldRef: element,
				errorMsg: 'Select Year'
			});
			return false;
		}
		else {
			return true;
		}
	}

	modalInstanceCancelClick() {
		this.dialogRef.close('Cancel was clicked.');
	}


}
